import { DTO, Formatters } from "shared-lib";
import customAxios from "./appservices";
import {
  PaginationParams,
  SearchParams,
  FilterParams,
  LoginRequest,
  RegisterRequest,
  EmailRequest,
  VerifyCodeRequest,
  ChangePasswordRequest,
  DeleteVehicleRequest,
  DeleteVehicleResponse,
  ApiResponse,
  RideListApiResponse,
  VehicleListApiResponse,
  VehicleSearchApiResponse,
  DriverStatusUpdate,
} from "types/api.types";
import {
  PaginatedDriverResponse,
  SearchDriverResponse,
} from "types/drivers-view.types";

export const dashboardDataApi = () => {
  return customAxios.get(`/dashboard-data`);
};

export const handleLoginApi = (data: LoginRequest) => {
  return customAxios.post("/admin-login", data);
};

export const handleRegisterApi = (data: RegisterRequest) => {
  return customAxios.post("/admin-register", data);
};
export const sendEmailforUser = (data: EmailRequest) => {
  return customAxios.post("/send-email", data);
};

export const verifyCodeEmail = (data: VerifyCodeRequest) => {
  return customAxios.post("/verify-code", data);
};
export const handleChangePasswordApi = (data: ChangePasswordRequest) => {
  return customAxios.post("/change-password", data);
};
export const onlineDriversApi = () => {
  return customAxios.get(`/onlineDrivers`);
};
export const getAllRidesApi = (
  data: PaginationParams,
): Promise<RideListApiResponse> => {
  return customAxios.get(
    `/get-all-rides?page=${data.page}&limit=${data.limit}`,
  );
};

export const getCurrentRidesApi = (
  data: PaginationParams,
): Promise<RideListApiResponse> => {
  return customAxios.get(
    `/get-current-rides?page=${data.page}&limit=${data.limit}`,
  );
};

export const getRidesByFilterApi = (
  data: FilterParams,
): Promise<RideListApiResponse> => {
  return customAxios.get(
    `/get-rides-by-filter?page=${data.page}&limit=${data.limit}&filter=${data.filter}`,
  );
};

export const searchRidesApi = (
  data: SearchParams,
): Promise<RideListApiResponse> => {
  return customAxios.get(
    `/search-ride?page=${data.page}&limit=${data.limit}&query=${data.query}`,
  );
};

export const searchDriversApi = (
  data: SearchParams
): Promise<SearchDriverResponse> => {
  return customAxios.get(
    `/search-drivers?page=${data.page}&limit=${data.limit}&query=${data.query}${data.status ? `&status=${data.status}` : ''}`
  );
};

export const getRideDetailsApi = (
  id: number
): Promise<ApiResponse<DTO.RideDTO>> => {
  return customAxios.get(
    `/get-ride-details/${id}`
  );
};

export const getRideTransactionsApi = (rideId: number) => {
  return customAxios.get(`/get-ride-transactions/${rideId}`);
};

export const getRideRatingsApi = (rideId: number) => {
  return customAxios.get(`/ratings/ride/${rideId}`);
};

export const deleteVehicleApi = (
  data: DeleteVehicleRequest
): Promise<DeleteVehicleResponse> => {
  const headers = {
    ...(data.profileImageKey && {
      "X-Profile-Image-Key": data.profileImageKey,
    }),
    ...(data.documentsKey?.length && {
      "X-Documents-Key": JSON.stringify(data.documentsKey),
    }),
  };

  return customAxios.delete(`/deleteVehicle/${data.id}`, { headers });
};

export const getPaginatedVehicleDataApi = (
  data: PaginationParams
): Promise<VehicleListApiResponse> => {
  return customAxios.get(
    `/paginatedVehicleData?page=${data.page}&limit=${data.limit}${data.status ? `&status=${data.status}` : ''}`
  );
};

export const getPaginatedRidesDataApi = (data: PaginationParams) => {
  return customAxios.post(`/paginatedRidesData`, data);
};

export const getPaginatedRidersDataApi = (data: PaginationParams) => {
  return customAxios.post(`/paginatedRidersData`, data);
};

export const searchVehiclesApi = (
  data: SearchParams
): Promise<VehicleSearchApiResponse> => {
  return customAxios.get(
    `/search-vehicles?page=${data.page}&limit=${data.limit}&query=${data.query}${data.status ? `&status=${data.status}` : ''}`
  );
};

export const deleteDriverHandleApi = async (id: number) => {
  return await customAxios.delete(`/deleteDriver/${id}`);
};

export const getPaginatedDriverDataApi = (
  data: PaginationParams
): Promise<PaginatedDriverResponse> => {
  return customAxios.get(
    `/paginatedDriverData?page=${data.page}&limit=${data.limit}${data.status ? `&status=${data.status}` : ''}`
  );
};

export const updateDriverStatusApi = (
  id: number,
  data: DriverStatusUpdate,
) => {
  return customAxios.patch(`/update-driver-status/${id}`, data);
};

export const getDriverLocationApi = (data: { driverId: number }) => {
  return customAxios.post(`/get-driver-location`, data);
};

export const getAvailableVehiclesApi = () => {
  return customAxios.get("/allAvailableVehicles");
};

export const getAllVehiclesApi = () => {
  return customAxios.get("/allAllVehicles");
};

export const updateDriver = (id: number, data: Partial<DTO.DriverDTO>) => {
  return customAxios.patch(`/update-driver/${id}`, data);
};

export const createDriverApi = (data: FormData) => {
  return customAxios.post("/create-driver", data);
};

// vehicle Type

export const createVehicleTypeApi = (data: Omit<DTO.VehicleTypeDTO, 'id'>) => {
  return customAxios.post("/create-vehicle-type", data);
};

export const handleCreateVehicleTypeApi = (id: number, data: Partial<DTO.VehicleTypeDTO>) => {
  return customAxios.patch(`/updateVehicleType/${id}`, data);
};

export const getVehicleTypeById = (id: number) => {
  return customAxios.get(`/get-vehicle-type-id/${id}`);
};

export const getVehicleTypeList = () => {
  return customAxios.get("/get-vehicle-type");
};

export const updateVehicleTypeCategory = (data: {
  currentCategoryId: number | null;
  newCategoryId: number;
}) => {
  return customAxios.put("/update-vehicle-type-category", data);
};

export const getVehicleCategoryList = (params?: { vehicleTypeId?: number, transportMode?: string, transportModes?: string[] }) => {
  const query = new URLSearchParams();
  if (params?.vehicleTypeId) query.append('vehicleTypeId', String(params.vehicleTypeId));
  if (params?.transportModes && params.transportModes.length > 0) {
    query.append('transportModes', params.transportModes.join(','));
  } else if (params?.transportMode) {
    query.append('transportMode', params.transportMode);
  }
  const queryString = query.toString();
  return customAxios.get(`/get-categories${queryString ? `?${queryString}` : ''}`);
};

export const deleteVehicleType = (id: number) => {
  return customAxios.delete(`/delete-vehicle-type/${id}`);
};

// ─── System Vehicle Types (new backend) ─────────────────────────────
export const getSystemVehicleTypes = () => {
  return customAxios.get("/vehicle-types");
};

export const toggleSystemVehicleType = (id: number) => {
  return customAxios.patch(`/vehicle-types/${id}/toggle`);
};

export const updateSystemVehicleType = (id: number, data: Partial<DTO.VehicleTypeDTO>) => {
  return customAxios.put(`/vehicle-types/${id}`, data);
};

export const getVehicleTypeCategories = (id: number) => {
  return customAxios.get(`/vehicle-types/${id}/categories`);
};

// ─── Rides Heatmap ──────────────────────────────────────────────────
export const getRidesHeatmapApi = (params?: { from?: string; to?: string; limit?: number }) => {
  const searchParams = new URLSearchParams();
  if (params?.from) searchParams.set("from", params.from);
  if (params?.to) searchParams.set("to", params.to);
  if (params?.limit) searchParams.set("limit", String(params.limit));
  return customAxios.get(`/rides/heatmap?${searchParams.toString()}`);
};

// fare

export const addFare = (data: Omit<DTO.FareDTO, 'id'>) => {
  return customAxios.post(`/add-fare`, data);
};

export const getFare = () => {
  return customAxios.get(`/get-fare`);
};

export const upDateFare = (id: number, data: Partial<DTO.FareDTO>) => {
  return customAxios.patch(`/update-fare/${id}`, data);
};

//

export const getDriverByIdApi = (id: number) => {
  return customAxios.get<DTO.DriverDTO>(`/getDriverById/${id}`);
};

export function updateVehicleApi(
  id: number,
  data: FormData,
): ReturnType<typeof customAxios.patch>;
export function updateVehicleApi(
  id: number,
  data: Partial<DTO.VehicleDTO>,
): ReturnType<typeof customAxios.patch>;
export function updateVehicleApi(
  id: number,
  data: FormData | Partial<DTO.VehicleDTO>,
) {
  return customAxios.patch(`update-vehicle/${id}`, data);
}

export const createVehicleApi = (data: Omit<DTO.VehicleDTO, 'id'>) => {
  return customAxios.post("/create-vehicle", data);
};

export const getVehicleByIdApi = (id: number) => {
  return customAxios.get<ApiResponse<DTO.VehicleDTO>, ApiResponse<DTO.VehicleDTO>>(
    `/get-vehicle-by-id/${id}`
  );
};
export const deleteCategoryApi = (id: number) => {
  return customAxios.delete(`/delete-category/${id}`);
};

export const toggleCategoryActive = (id: number, active: boolean) => {
  return customAxios.patch(`/update-category/${id}`, { active });
};

export const searchRidersByNameApi = (data: SearchParams) => {
  return customAxios.get(
    `/search-riders-by-name?page=${data.page}&limit=${data.limit}&query=${data.query}`,
  );
};

export const updateRiderStatusApi = (data: DTO.UpdateRiderStatusRequestDTO) => {
  return customAxios.patch(`/update-rider-status`, data);
};

export const handleRiderDeleteApi = (id: number) => {
  return customAxios.delete(`/deleteRider/${id}`);
};

export const getAllRidersApi = (
  data: PaginationParams,
): Promise<DTO.RiderListResponseDTO> => {
  return customAxios.get(
    `/get-all-riders?page=${data.page}&limit=${data.limit}`
  );
};

export const searchRidersApi = (
  data: SearchParams,
): Promise<DTO.RiderSearchResponseDTO> => {
  return customAxios.get(
    `/search-riders-by-name?page=${data.page}&limit=${data.limit}&query=${data.query}`
  );
};

export const chatGptAPi = (data: { message: string }) => {
  return customAxios.post(`/chat-gpt-api`, data);
};

export const getAppConfigs = () => {
  return customAxios.get(`/get-app`);
};
export const getCategory = (id: number) => {
  return customAxios.get(`/get-category/${id}`);
};

export const createAppConfig = (data: DTO.AppDto) => {
  return customAxios.post("/create-app", data);
};

// Application configs

export const updateAppConfig = (name: string, data: DTO.AppDto) => {
  return customAxios.patch(`/update-app-config/${name}`, data);
};
export function updateCategory(
  id: number,
  data: FormData,
): ReturnType<typeof customAxios.patch>;
export function updateCategory(
  id: number,
  data: Partial<DTO.CategoryDTO>,
): ReturnType<typeof customAxios.patch>;
export function updateCategory(
  id: number,
  data: FormData | Partial<DTO.CategoryDTO>,
) {
  return customAxios.patch(`/update-category/${id}`, data);
}

export const getAppConfig = (name: string) => {
  return customAxios.get(`/get-app-config/${name}`);
};

export const deleteAppConfig = (name: string) => {
  return customAxios.delete(`/delete-app-config/${name}`);
};

export const getAdminMercadoPagoOAuthUrlApi = () => {
  return customAxios.get(`/mercadopago/admin/oauth-url`);
};

//spots

export const createSpot = (data: Omit<DTO.SpotDTO, 'id'>) => {
  return customAxios.post("/create-spot", data);
};

export const getSpotsList = (data: PaginationParams) => {
  return customAxios.get(
    `/get-spot-list?page=${data.page}&limit=${data.limit}`
  );
};

export const getSpotsListVehicle = () => {
  return customAxios.get(`/get-spot-list-vehicle`);
};

export const deleteSpot = (id: number) => {
  return customAxios.delete(`/delete-spot/${id}`);
};

export const getActiveSpots = () => {
  return customAxios.get(`/get-active-spot`);
};


export const formatCurrency = Formatters.formatCurrency;

export const coordsToLatLng = (coords?: number[]) => {
  if (coords?.length !== 2) {
    return undefined;
  }
  return { longitude: coords[0], latitude: coords[1] };
};

export function createCategory(
  data: FormData,
): ReturnType<typeof customAxios.post>;
export function createCategory(
  data: DTO.CategoryDTO,
): ReturnType<typeof customAxios.post>;
export function createCategory(data: FormData | DTO.CategoryDTO) {
  return customAxios.post(`/create-category`, data);
}
export const fetchCategories = () => {
  return customAxios.get(`/get-categories`);
};

// Admin CRUD APIs
export interface AdminData {
  id?: number;
  name: string;
  email: string;
  password?: string;
  createdAt?: string;
  updatedAt?: string;
}

export const getAllAdminsApi = () => {
  return customAxios.get('/admins');
};

export const getAdminByIdApi = (id: number) => {
  return customAxios.get(`/admins/${id}`);
};

export const createAdminApi = (data: { name: string; email: string; password: string }) => {
  return customAxios.post('/admins', data);
};

export const updateAdminApi = (id: number, data: Partial<AdminData>) => {
  return customAxios.patch(`/admins/${id}`, data);
};

export const deleteAdminApi = (id: number) => {
  return customAxios.delete(`/admins/${id}`);
};

// Rating Admin APIs
export const getAllRatingsAdminApi = (
  page: number = 1,
  limit: number = 10,
  filters?: { raterType?: string; reported?: string },
) => {
  const params = new URLSearchParams();
  params.set('page', String(page));
  params.set('limit', String(limit));
  if (filters?.raterType) params.set('raterType', filters.raterType);
  if (filters?.reported) params.set('reported', filters.reported);
  return customAxios.get(`/ratings/admin/all?${params.toString()}`);
};

export const rejectRatingAdminApi = (ratingId: number) => {
  return customAxios.delete(`/ratings/admin/${ratingId}`);
};

// ─── Help Center ────────────────────────────────────────────────────
export const getHelpArticles = (params?: { audience?: string; q?: string; category?: string }) => {
  const search = new URLSearchParams();
  if (params?.audience) search.set('audience', params.audience);
  if (params?.q) search.set('q', params.q);
  if (params?.category) search.set('category', params.category);
  return customAxios.get(`/help/articles?${search.toString()}`);
};
export const getHelpArticle = (id: number) => customAxios.get(`/help/articles/${id}`);
export const createHelpArticle = (data: any) => customAxios.post('/help/articles', data);
export const updateHelpArticle = (id: number, data: any) => customAxios.patch(`/help/articles/${id}`, data);
export const deleteHelpArticle = (id: number) => customAxios.delete(`/help/articles/${id}`);
export const getHelpContacts = () => customAxios.get('/help/contacts');
export const getAllHelpContacts = () => customAxios.get('/help/contacts/all');
export const createHelpContact = (data: any) => customAxios.post('/help/contacts', data);
export const updateHelpContact = (id: number, data: any) => customAxios.patch(`/help/contacts/${id}`, data);
export const deleteHelpContact = (id: number) => customAxios.delete(`/help/contacts/${id}`);

// ─── Disputes ───────────────────────────────────────────────────────
export const getDisputes = (params?: { status?: string; rideId?: number; page?: number; limit?: number }) => {
  const search = new URLSearchParams();
  if (params?.status) search.set('status', params.status);
  if (params?.rideId) search.set('rideId', String(params.rideId));
  if (params?.page) search.set('page', String(params.page));
  if (params?.limit) search.set('limit', String(params.limit));
  return customAxios.get(`/disputes?${search.toString()}`);
};
export const getDispute = (id: number) => customAxios.get(`/disputes/${id}`);
export const updateDispute = (id: number, data: any) => customAxios.patch(`/disputes/${id}`, data);
export const createDisputeMessage = (id: number, data: any) => customAxios.post(`/disputes/${id}/messages`, data);
export const getDisputeMessages = (id: number, visibleTo?: string) => {
  const params = visibleTo ? `?visibleTo=${visibleTo}` : '';
  return customAxios.get(`/disputes/${id}/messages${params}`);
};
export const getRideDisputes = (rideId: number) => customAxios.get(`/rides/${rideId}/disputes`);

// ─── Tutorials ──────────────────────────────────────────────────────
export const getTutorials = (audience?: string) => {
  const params = audience ? `?audience=${audience}` : '';
  return customAxios.get(`/tutorials${params}`);
};
export const getAllTutorials = () => customAxios.get('/tutorials/all');
export const getTutorial = (id: number) => customAxios.get(`/tutorials/${id}`);

// ─── Admin Tutorials (read-only, from .md files) ────────────────────
export const getAdminTutorials = () => customAxios.get('/admin-tutorials');
export const getAdminTutorial = (slug: string) => customAxios.get(`/admin-tutorials/${slug}`);

// ─── Cancel Policy ──────────────────────────────────────────────────
export const getCancelPolicy = () => customAxios.get('/cancel-policy');

// ─── Payment Refund ─────────────────────────────────────────────────
export const refundRidePaymentApi = (data: { rideId: number; reason?: string; amount?: number }) =>
  customAxios.post('/refund-ride', data);
